export interface VerticalPlaylistSummaryInput {
  contentMode: string;
  itemIds: string[];
  status: string;
}

export interface VerticalScheduleSlotInput {
  contentMode: string;
  startsAt: string;
  endsAt: string;
  playlistId?: string;
}

export function summarizeBloodCrimesTvVerticalSchedule(
  playlists: readonly VerticalPlaylistSummaryInput[],
  schedule: readonly VerticalScheduleSlotInput[],
  nowMs = Date.now(),
) {
  const approved = playlists.filter((playlist) => playlist.status === 'APPROVED');
  const music = approved.find((playlist) => playlist.contentMode === 'MUSIC_SHORTS');
  const cases = approved.find((playlist) => playlist.contentMode === 'CASE_FILE_SHORTS');
  const endMs = schedule.reduce((latest, slot) => {
    const parsed = Date.parse(slot.endsAt);
    return Number.isFinite(parsed) ? Math.max(latest, parsed) : latest;
  }, 0);
  const hoursRemaining = endMs > nowMs ? (endMs - nowMs) / 3_600_000 : 0;
  const orderedSchedule = [...schedule].sort((left, right) => Date.parse(left.startsAt) - Date.parse(right.startsAt));
  const firstStartsAt = orderedSchedule.length ? Date.parse(orderedSchedule[0]!.startsAt) : Number.NaN;
  const firstEndsAt = orderedSchedule.length ? Date.parse(orderedSchedule[0]!.endsAt) : Number.NaN;
  const coversNow = Number.isFinite(firstStartsAt) && Number.isFinite(firstEndsAt) && firstStartsAt <= nowMs && firstEndsAt > nowMs;
  let gaps = 0;
  let overlaps = 0;
  let repeatedPlaylistTransitions = 0;
  for (let index = 1; index < orderedSchedule.length; index += 1) {
    const previous = orderedSchedule[index - 1]!;
    const current = orderedSchedule[index]!;
    const previousEnd = Date.parse(previous.endsAt);
    const currentStart = Date.parse(current.startsAt);
    if (!Number.isFinite(previousEnd) || !Number.isFinite(currentStart)) continue;
    if (currentStart > previousEnd) gaps += 1;
    if (currentStart < previousEnd) overlaps += 1;
    const samePlaylist = previous.playlistId && current.playlistId
      ? previous.playlistId === current.playlistId
      : previous.contentMode === current.contentMode;
    if (samePlaylist) repeatedPlaylistTransitions += 1;
  }

  return {
    musicItems: music?.itemIds.length ?? 0,
    caseFileItems: cases?.itemIds.length ?? 0,
    hasMusicPlaylist: Boolean(music),
    hasCaseFilePlaylist: Boolean(cases),
    scheduledBlocks: schedule.length,
    coversCurrentTime: coversNow,
    checkedContinuity: schedule.length > 1,
    scheduleGaps: gaps,
    scheduleOverlaps: overlaps,
    repeatedPlaylistTransitions,
    scheduleContinuous: schedule.length > 1 && coversNow && gaps === 0 && overlaps === 0,
    scheduleEndsAt: endMs ? new Date(endMs).toISOString() : null,
    hoursRemaining,
    covers24Hours: hoursRemaining >= 24,
  };
}
